// 1st Party
import {
    queryInput,
    querySelect
} from './utilities';

export const quote = {

    // Inputs

    property: {
        fullAddress:   queryInput('PropertyAddress.FullAddress'),
        addressStreet: queryInput('PropertyAddress.StreetAddress'),
        unitNumber:    queryInput('PropertyAddress.UnitNumber'),
        city:          queryInput('PropertyAddress.City'),
        state:         queryInput('PropertyAddress.State'),
        zipCode5:      queryInput('PropertyAddress.ZipCode5'),
        zipCode4:      queryInput('PropertyAddress.ZipCode4'),
        country:       queryInput('PropertyAddress.Country'),
        county:        queryInput('PropertyAddress.County')
    },
    mailing: {
        fullAddress:   queryInput('Insured.Address.FullAddress'),
        addressStreet: queryInput('Insured.Address.StreetAddress'),
        unitNumber:    queryInput('Insured.Address.UnitNumber'),
        city:          queryInput('Insured.Address.City'),
        state:         queryInput('Insured.Address.State'),
        zipCode5:      queryInput('Insured.Address.ZipCode5'),
        zipCode4:      queryInput('Insured.Address.ZipCode4'),
        country:       queryInput('Insured.Address.Country'),
        county:        queryInput('Insured.Address.County')
    },
    espanolEmail: {
        fullAddress: queryInput('EspanolEmail.FullAddress'),
        unitNumber: queryInput('EspanolEmail.UnitNumber'),
        occupancy: querySelect('EspanolEmail.Occupancy'),
        firstName: queryInput('EspanolEmail.FirstName'),
        lastName: queryInput('EspanolEmail.LastName'),
        emailAddress: queryInput('EspanolEmail.Email'),
        phoneNumber: queryInput('EspanolEmail.PhoneNumber'),
        newPurchase: querySelect('EspanolEmail.IsNewPurchase'),
        buttonSubmit: $('.wm-es-js-quote-box__submit-button')
    },
    firstName: queryInput('Insured.FirstName'),
    middleName: queryInput('Insured.MiddleName'),
    lastName:                     queryInput('Insured.LastName'),
    squareFoot:                   queryInput('PropertyMinimalInformationData.SquareFoot'),
    yearBuilt:                    queryInput('PropertyMinimalInformationData.YearBuilt'),
    sameAddress:                  queryInput('Insured.IsMailingAddressSameAsProperty'),
    occupancyInput:               queryInput('OccupancyType'),
    googleTypeAheadInput:         queryInput('IsPickedFromGoogleList'),
    policyOriginationMediumInput: queryInput('PolicyOriginationMedium'),
    salesAgentIdInput:            queryInput('SalesAgentId'),
    newPurchase:                  queryInput('IsNewPurchase'),
    emailAddress:                 queryInput('EmailAddress'),
    phoneNumber:                  queryInput('PhoneNumber'),
    gclid:                        queryInput('gclid'),
    msclkid:                      queryInput('msclkid'),
    fbclid:                       queryInput('fbclid'),
    currentDominoPolicy:          queryInput('CurrentDominoPolicy'),
    priorDominoPolicy:            queryInput('PriorDominoPolicy'),
    leadSourceInput:              queryInput('LeadSource'),
    IsAgentPageLeadInput:         queryInput('IsAgentPageLead'),

    // Quote box

    quoteBox:              $('.wm-js-quote-box'),
    form:                  $('.wm-js-quote-box__form'),
    espanolForm:           $('.wm-js-espanol-quote-box__form'),
    addressInputContainer: $('.wm-js-quote-box__address-input-container'),
    button:                $('.wm-js-quote-box__flip-button'),
    buttonExit:            $('.wm-js-quote-box__exit'),
    ccpa:                  $('.wm-js-quote-box .ccpaModalLink'),
    buttonSubmit:          $('.wm-js-quote-box__submit-button'),
    flipContainer:         $('.wm-js-quote-box__flip-container'),
    products:              $('.wm-js-product-item'),
    productIcons:          $('.wm-js-quote-box__product-item-icon'),
    mobileProducts:        $('.wm-js-products--mobile'),
    policyInput:           $('.wm-js-policy-input'),
    producerCodeInput:     $('.wm-js-producer-code-input'),
    heroContainer:         $('.wm-js-hero'),
    agentQuoteButton:      $('.wm-js-agent-quote-button'),
    agentQuoteContainer:   $('.wm-js-agent-quote__container'),

    // Address

    addressForm:     $('.wm-address-form'),
    propertyType:    $('#propertyType'),
    gaTrackingId:    $('.gaTrackingId'),
    homeQuoteButton: $('.wm-js-home-quote-button'),

    // Espanol

    espanolExit:    $('.wm-js-espanol-quote-box__success-exit'),
    espanolSuccess: $('.wm-js-espanol-quote-box__success')
};

export const retrieve = {
    form: $('.wm-retrieve-quote-form'),
    mobileForm: $('.wm-retrieve-quote-form-mobile'),
    qrForm: $('.wm-retrieve-quote-form-qr'),
    link: $('.wm-navbar-nav__retrieve-quote'),
    main: $('.wm-retrieve-quote'),
    buttonSubmit: $('.wm-retrieve-quote__button'),
    ccpa: $('.wm-retrieve-quote-form .ccpaModalLink'),
    exit: $('.wm-retrieve-quote__exit'),
    referenceNumber: queryInput('PolicyNumber'),
    zipCode5: queryInput('ZipCode5'),
    backMobile: $('#mobile-retrieve-back'),
    referenceNumberMobile: $('#policy-mobile'),
    zipCode5Mobile: $('#zipcode-mobile'),
    referenceNumberQR: $('#policy-qr'),
    zipCode5QR: $('#zipcode-qr'),
    ccpaMobile: $('#ccpa-mobile'),
    buttonSubmitMobile: $('#retrieve-button-mobile'),
    gaTrackingId: $('.gaTrackingId')
};


export const loginForm = {
    form: $('.wm-login-popup-form'),
    link: $('.wm-navbar-nav__wm-login-popup'),
    main: $('.wm-login-popup'),
    exit: $('.wm-login-popup__exit'),
    loginForm: $('.wm-login-popup'),
    mobileForm: $('.wm-login-popup-mobile'),
    buttonSubmit: $('.wm-login-popup__button'),
    userName: $('#Input_UserName'),
    password: $('#Input_Password')
};


export const refer = {
    form: $('.wm-hero__refer-box-form')
};

export const login = {
    link: $('.wm-navbar-nav__login'),
    main: $('.wm-login'),
    exit: $('.wm-login__exit')
};

export const ui = {
    collapse: {
        link: $('.collapse-link')
    }
};

export const agents = {
    quoteButton: $('.wm-agent-quote-button')
};